var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { attrs: { for: _vm.locationElementKey } }, [
    _c("input", {
      staticClass: "input-location",
      attrs: {
        id: _vm.locationElementKey,
        type: "radio",
        name: "data[Order][location]",
        disabled: !_vm.location.available,
      },
      domProps: {
        value: _vm.locationElementValue,
        checked: _vm.selectedLocation === _vm.location,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("location-select", _vm.location)
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "panel",
        class: { "is-disabled": !_vm.location.available },
      },
      [
        _c(
          "strong",
          {
            staticClass: "panel__title",
            attrs: { "data-test-location": _vm.location.city },
          },
          [_vm._v(_vm._s(_vm.location.country) + "\n    ")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "panel__hint" }, [
          _c("img", {
            staticClass: "panel-flag",
            attrs: { src: _vm.locationImage },
          }),
          _vm._v("\n      " + _vm._s(_vm.location.city) + "\n    "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }